import React, { useState } from 'react'
import universe from '../img/logo_final_png.png'
import universeWhite from '../img/logo_final_png.png'
import circle from '../img/circulogris.png';
import { ReactComponent as MessageIcon } from '../img/ic_mensajes.svg';
import { ReactComponent as NotificationIcon } from '../img/ic_notificaciones.svg';
import { ReactComponent as NewPostIcon } from '../img/ic_publicar.svg';
import Logout from '../components/User/Logout';
import ModalNewPost from './ModalNewPost';
import ModalNotification from '../components/User/ModalNotification';
import ModalMessages from '../components/Rooms/ModalMessages';
import { logout } from '../actions/authActions'
import { connect } from 'react-redux'
import ModalMenu from './ModalMenu';
import ModalSearchBar from './ModalSearchBar';
import ModalMenuClose from './ModalMenuClose';
import localStorage from '../utils/hooks/useLocalStorage';

const NavBar = ({ history, styleNavBar, logout }) => {

    const [isShowNotification, setIsShowNotification] = useState(false)
    const [isShowMessages, setIsShowMessages] = useState(false)
    const [isShowNewPost, setIsShowNewPost] = useState(false)
    const [notification, setNotification] = useState(0)

    const selectNotification = (e) => {
        e.stopPropagation()
        setIsShowNewPost(false)
        setIsShowMessages(false)
        setIsShowNotification(!isShowNotification)
    }

    const selectMessages = (e) => {
        e.stopPropagation()
        setIsShowNewPost(false)
        setIsShowNotification(false)
        setIsShowMessages(!isShowMessages)
    }

    const selectNewPost = (e) => {
        e.stopPropagation()
        setIsShowMessages(false)
        setIsShowNotification(false)
        setIsShowNewPost(!isShowNewPost)
    }

    const closeModals = () => {
        setIsShowNewPost(false)
        setIsShowMessages(false)
        setIsShowNotification(false)
    }

    const contentModal = <div className='scroll-menu modal-menu-navbar-content'>
        <div className="modal-menu-navbar-content-items">
            <div>
                <div className="mb-4">Menú</div>
                <div onClick={() => { history.push('/PersonalInfo') }} className="pointer mb-2"> Informacion personal</div>
                <div onClick={() => { history.push('/ResetPassword') }} className="pointer mb-2"> Cambio de contraseña</div>
                <div onClick={() => { history.push('/BlockedFriendList') }} className="pointer mb-2"> Bloqueos</div>
                {localStorage().getItem("professionalID") ?
                    <div onClick={() => { history.push('/ProfessionalProfile') }} className="pointer mb-2"> Cambiar a cuenta profesional</div>
                    :
                    <div onClick={() => { history.push('/ProfessionalProfileMessage') }} className="pointer mb-2"> Cambiar a cuenta profesional</div>
                }

                <Logout
                    renderClose={<div onClick={() => {
                        logout()
                        history.push('/Login')
                    }} >
                        <button className="btn btn-purple btn-small">Cerrar sesion</button>
                    </div>}
                />

            </div>
        </div>
    </div>

    const contentModalProfesional = <div className='scroll-menu modal-menu-navbar-content text-black'>
        <div className="modal-menu-navbar-content-items">
            <div>
                <div className="mb-4">Menú</div>
                <div onClick={() => { history.push('/Professional/EditProfessionalProfile') }} className="pointer mb-2"> Informacion personal</div>
                <div onClick={() => { history.push('/ResetPassword') }} className="pointer mb-2"> Cambio de contraseña</div>
                <div onClick={() => { history.push('/') }} className="pointer mb-2"> Cambiar a personal</div>
                <Logout
                    renderClose={<div onClick={() => {
                        logout()
                        history.push('/Login')
                    }} >
                        <button className="btn btn-purple btn-small">Cerrar sesion</button>
                    </div>}
                />

            </div>
        </div>
    </div>

    return (
        <div onClick={closeModals} className={`wrapper-navbar navbar column ${styleNavBar === 'navBar-professional-profile' && styleNavBar}`}>
            <div className="column centerItems ml-5" >
                <img onClick={() => { styleNavBar !== 'navBar-professional-profile' && history.push('/') }} alt="img" className="img-logo-navbar" src={styleNavBar === 'navBar-professional-profile' ? universeWhite : universe}></img>
            </div >
            <div className="content-search-bar row centerContent endItems">
                <ModalSearchBar history={history} isProfessionalUser={styleNavBar === 'navBar-professional-profile' ? true : false} />
            </div>
            <div className="column centerItems endContent ml-3">
                <div className="column centerItems navbar-higth parent-width startContent mr-5">
                    <div className="notification-navbar column centerItems mr-4">
                        <div onClick={(e) => selectNewPost(e)} className="new-post-svg column centerItems centerContent ">
                            <NewPostIcon className="cls-1 white-svg" height="13" width="13" />
                        </div>
                    </div>
                    <ModalNewPost
                        isProfessionalUser={styleNavBar === 'navBar-professional-profile' ? true : false}
                        nameUser={styleNavBar === 'navBar-professional-profile' ? localStorage().getItem("nameProfileProfesional") : localStorage().getItem("nameUser")}
                        urlUser={styleNavBar === 'navBar-professional-profile' ? localStorage().getItem("picturProfileProfesional") : localStorage().getItem("picturProfile")}
                        history={history}
                        displayModal={isShowNewPost}
                        closeModal={selectNewPost}
                        content={"new post"}
                    />
                    <div onClick={(e) => selectNotification(e)} className="notification-navbar column centerItems mr-5">
                        <NotificationIcon className={` cls-1  ${styleNavBar === 'navBar-professional-profile' && 'white-svg'}`} height="20" width="20" />
                        {notification > 0 && <span onClick={(e) => selectNotification(e)} className="span-navbar-notification ">{notification}</span>}
                    </div>
                    <ModalNotification
                        isProfessionalUser={styleNavBar === 'navBar-professional-profile' ? true : false}
                        history={history}
                        displayModal={isShowNotification}
                        closeModal={selectNotification}
                        setNotification={setNotification}
                    />
                    <div className="notification-navbar column centerItems">
                        <MessageIcon className={` cls-1  ${styleNavBar === 'navBar-professional-profile' && 'white-svg'}`} height="20" width="20" />
                        {false && <span onClick={(e) => selectMessages(e)} className="span-navbar-notification"></span>}
                    </div>
                    {/* <ModalMessages
                        displayModal={isShowMessages}
                        closeModal={selectMessages}
                        content={"mensajes"}
                    /> */}


                </div>
                <div className="navbar-higth column centerItems endContent">
                    {styleNavBar === 'navBar-professional-profile' ?
                        <div onClick={() => history.push('ProfessionalProfile')}
                            className="text-name-navbar mr-2">{localStorage().getItem("nameProfileProfesional") ? localStorage().getItem("nameProfileProfesional").split(' ')[0] : 'Welcome'}
                        </div>
                        :
                        <div
                            onClick={(e) => {
                                e.preventDefault()
                                styleNavBar === 'navBar-professional-profile' ?
                                    history.push('ProfessionalProfile')
                                    :
                                    history.push({
                                        pathname: '/ReloadData',
                                        state: {
                                            route: '/Profile/',
                                            idData: localStorage().getItem("idUser")
                                        }
                                    })
                            }} className="text-name-navbar mr-2">{localStorage().getItem("nameUser") ? localStorage().getItem("nameUser").split(' ')[0] : 'Welcome'}
                        </div>}


                    {styleNavBar === 'navBar-professional-profile' ?
                        <ModalMenuClose
                            contentButton={localStorage().getItem("picturProfileProfesional") ? <img alt="img" className="img-navbar-profile mr-2" onError={(e) => e.target.src = circle} src={localStorage().getItem("picturProfileProfesional")}></img> :
                                <img alt="img" className="img-navbar-profile mr-2" src={circle}></img>
                            }
                            contentModal={contentModalProfesional}
                        /> :
                        <ModalMenuClose
                            contentButton={localStorage().getItem("picturProfile") ? <img alt="img" className="img-navbar-profile mr-2" onError={(e) => e.target.src = circle} src={localStorage().getItem("picturProfile")}></img> :
                                <img alt="img" className="img-navbar-profile mr-2" src={circle}></img>
                            }
                            contentModal={contentModal}
                        />
                    }

                </div>
            </div>
        </div>
    )
}

export default connect(null, { logout })(NavBar)
